import _ = require("underscore");
import Base = require("./base-command");
import Portal = require("portal-gis");

class RadioCommand<T> extends Base<T> {

    static about = `
Place this command in a group of mutually exclusive commands.
    `;

    static options = {
        "radio-group": {
            "about": "Commands sharing this group are considered to be mutually exclusive",
            "default": "geo-selection",
        }
    }

    stop() {
        // remove/unregister/suspend/unload/deactivate or whatever
    }

    go() {
        // activate/run or whatever
    }

    execute(args = this.args) {
        let mediator = this.mediator;
        let command = this.configuration;

        let config = _.defaults(this.options, {
            "radio-group": RadioCommand.options['radio-group'].default
        });
        let toolId = command.id;

        let tool = <RadioCommand<T>>mediator.model.get(toolId);

        if (!tool) {
            let h = mediator.on("radio-group", (args: {
                out: {
                    group: string;
                    command: Portal.CommandLeaf;
                }
            }) => {
                if (args.out.group !== config["radio-group"]) return;

                // destroy it
                if (tool) {
                    h.off(); // no more notifications, dropping out of the race
                    tool.stop();
                    mediator.model.set(toolId, tool = null);
                    return;
                }

                // if activating this tool and it does not exist, create it
                if (args.out.command === command) {
                    tool = this;
                    mediator.model.set(toolId, tool);
                    tool.go();
                }

            });

            // do nothing if the tool already exists, ignore the click
            this.trigger("radio-group", {
                command: command,
                group: config["radio-group"]
            });

        }


    }

}

export = RadioCommand; 